import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useChatStore } from '@/store';
import useResponsiveness from '@/hooks/useResponsiveness';
import WorkProjectFolderButton from './WorkProjectFolderButton';
import { isDraftComposerConversationId } from './composerActionSlot';

export default function WorkComposerProjectBar({ conversationId, projectName, isDisabled = false }) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const isDraft = isDraftComposerConversationId(conversationId);
  const taskId = useChatStore(state => {
    if (isDraft) return null;
    const session = state.chats.find(chat => chat.id === conversationId)?.coworkerSession;
    const id = typeof session === 'object' ? session?._id || session?.id : session;
    return id ? String(id) : null;
  });

  if (Platform.OS === 'macos' || (Platform.OS === 'web' && !isXS)) return null;
  if (!isDraft && !taskId) return null;

  // Let the platform control own visibility so chats without a folder do not
  // leave an empty row. Web only displays existing, read-only project context.
  return <WorkProjectFolderButton taskId={taskId} projectName={projectName} isDisabled={isDisabled}
    style={[styles.bar, { backgroundColor: colors.solid_color_tertiary }]}
    labelStyle={styles.label} />;
}

const styles = StyleSheet.create({
  bar: {
    minHeight: 44,
    flexShrink: 0,
    alignSelf: 'stretch',
    marginHorizontal: 12,
    marginBottom: 6,
    paddingHorizontal: 10,
    borderRadius: 10,
  },
  label: { flex: 1, minWidth: 0, maxWidth: '100%' },
});
